import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import SimpleDeviationGridBlock from '../../_partials/SimpleDeviationGridBlock';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SidebarBlock from '../../_partials/SidebarBlock';
import MobileThumbList from '../../_partials/MobileThumbList';
var Recommended = function (_a) {
    var recommended = _a.recommended, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    var isMobile = useContext(MobileContext);
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'recommended' } }, isMobile ? (React.createElement(React.Fragment, null, recommended && recommended.length > 0 && (React.createElement(SidebarBlock, { streamKey: "recommended", isLoading: isLoading },
        React.createElement(MobileThumbList, { deviations: recommended }))))) : (React.createElement(SimpleDeviationGridBlock, { streamKey: "recommended", parentDeviation: parentDeviation, deviations: recommended, isLoading: isLoading }))));
};
Recommended.displayName = 'Recommended';
export default Recommended;
//# sourceMappingURL=Recommended.js.map